export default {
  brandSub: "By Galano-Pacifico Law Firm & International Partners",
  nav: ["Jurisdictional Framework", "Institutional Advantage", "Arbitral Workflow", "Adjudicating Panel", "Pricing & Governance", "Press & Investors"],
  initiate: "Initiate Secure Arbitration",
  portalLabel: "Client Portal",
  splash: {
    est: "Est. MMXXVI — Sovereign Tribunal",
    states: "172 Signatory States",
    copy: "Welcome to LexAegis International, the world's premier and most authoritative international extra-judicial arbitration system. We deliver autonomous, legally binding adjudicative decisions with immediate executive force across global jurisdictions, bridging technological efficiency with strict compliance to international arbitration law.",
    enter: "Enter Sovereign Docket",
    convention: "1958 New York Convention",
    auto: "Auto-entering docket…",
  },
  hero: {
    overline: "Institutional Extra-Judicial Tribunal",
    l1: "Global Legal Excellence.",
    l2: "Instant Resolution.",
    sub: "The preeminent platform for authoritative international arbitration and dispute resolution, delivering immediate, binding legal enforceability worldwide.",
    secondary: "Explore Jurisdictional Framework",
    stats: [
      { value: "172", label: "New York Convention States", sub: "Enforceability Guarantee" },
      { value: "14 Days", label: "Average Award Issuance", sub: "vs 18 Months Traditional" },
      { value: "100%", label: "eIDAS & GDPR Compliant", sub: "Immutable Digital Docket" },
      { value: "$4.8B+", label: "Claims Adjudicated", sub: "Cross-Border Commercial" },
    ],
  },
  marquee: [
    "1958 New York Convention Recognized",
    "UNCITRAL Arbitration Rules Compliant",
    "eIDAS Qualified Electronic Timestamping",
    "ISO/IEC 27001:2022 Certified Security",
    "GDPR Article 32 Encrypted Docket",
    "Cross-Border Binding Enforceability",
    "Governed by Galano-Pacifico & International Partners",
  ],
  framework: {
    overline: "Jurisdictional Framework",
    titleA: "Authority anchored in",
    titleB: "treaty law",
    titleC: ", not promises.",
    body: "LexAegis does not operate in a legal vacuum. Every procedural order, every sealed exhibit, and every final award is engineered to satisfy the strictest tests of international arbitration law — so the outcome holds wherever your counterparty resides.",
    artLabel: "Recognition & Enforcement",
    pillars: [
      { title: "1958 New York Convention", body: "Awards issued by the LexAegis tribunal are recognizable and enforceable in all 172 contracting states, without re-litigation of merits before national courts." },
      { title: "UNCITRAL Model Rules", body: "Procedural conduct follows the UNCITRAL Arbitration Rules, guaranteeing due process, party equality, and full rights of representation at every stage." },
      { title: "Cross-Border Execution", body: "Certified awards are dispatched directly to enforcement registries, bailiff networks, and diplomatic legal channels in the respondent's jurisdiction." },
    ],
  },
  advantage: {
    overline: "The LexAegis Paradigm",
    titleA: "Dual-Layer",
    titleB: "Judicial Integrity",
    body: "Machine-precision evidence triage and asynchronous digital dockets accelerate the process — but every final decision is rendered exclusively by accredited human arbitrators, jurists, and former magistrates. Technology serves the law; it never replaces judgment.",
    guarantee: "Institutional Guarantee",
    items: [
      { title: "AI-Assisted Jurisdictional Triage", desc: "Automated cross-referencing of international treaties, forum selection clauses, and conflict-of-laws principles to establish instant prima facie jurisdiction.", badge: "Automated Rigor" },
      { title: "Elite Adjudication Panel", desc: "Former high court magistrates, accredited arbitrators, and specialized international jurists personally review and issue final binding awards.", badge: "Human Authority" },
      { title: "Immutable eIDAS Timestamping", desc: "Every evidence submission, pleading, and procedural order is cryptographically sealed with legal-grade timestamps valid in court.", badge: "Evidentiary Seal" },
      { title: "New York Convention Execution", desc: "Issued arbitral awards carry direct enforceability in 172 signatory nations under international law, bypassing state judicial bottlenecks.", badge: "Global Enforcement" },
    ],
  },
  workflow: {
    overline: "Manifesto & Procedure",
    titleA: "The 4-Step",
    titleB: "Arbitral Protocol",
    side: "From claim lodgement to a binding, cross-border enforceable award — a disciplined procedural chain with no procedural dead-ends.",
    note: "Procedural Note",
    steps: [
      { title: "Smart Onboarding & Jurisdictional Validation", desc: "The claimant submits dispute parameters and the arbitration agreement clause. LexAegis automated systems verify signatory authority and forum suitability.", details: "Includes claim valuation calculator, respondent notice dispatch, and initial jurisdictional check under UNCITRAL rules." },
      { title: "Secure Digital Docket & Sealed Pleadings", desc: "Parties access an end-to-end encrypted virtual chamber. All evidence, counter-claims, and legal briefs are timestamped per eIDAS standards.", details: "Zero-trust access control with AES-256 vault storage and instant multi-jurisdictional notification system." },
      { title: "Preliminary AI Legal Review & Panel Hearing", desc: "Our neural engine pre-screens precedent case law and contractual clauses before handing the docket to the assigned senior tribunal arbitrators.", details: "Conducted via asynchronous digital testimony or optional encrypted virtual tribunal sessions." },
      { title: "Issuance of Final Binding Arbitral Award", desc: "The tribunal renders a definitive, non-appealable award with full written legal rationale, certified for cross-border execution under the NY Convention.", details: "Direct dispatch to local enforcement bailiffs and diplomatic legal registries as requested." },
    ],
  },
  panel: {
    overline: "Verified Jurists",
    titleA: "Distinguished",
    titleB: "Tribunal Roster",
    body: "Independent international arbitrators committed to absolute impartiality and legal precision. Credentials verified against issuing institutions.",
    verified: "Verified",
    awards: "Awards Issued",
    members: [
      { role: "Former High Court Magistrate", spec: "International Commercial & Maritime Arbitration", jur: "London / Singapore — LCIA & SIAC Accredited" },
      { role: "Senior Arbitrator & IP Jurist", spec: "Cross-Border Technology & Patent Disputes", jur: "Geneva / Zurich — WIPO Neutral" },
      { role: "Emeritus International Law Chair", spec: "Sovereign State & Investor Disputes", jur: "The Hague / Vienna — ICSID Panel Member" },
    ],
  },
  pricing: {
    overline: "Transparent Fee Schedule",
    titleA: "Fixed-Tier",
    titleB: "Arbitral Pricing",
    body: "No hidden billable hours. Transparent administrative and tribunal fees based on total claim value — full predictability against traditional court litigation.",
    calcLabel: "Claim Value (USD)",
    calcPlaceholder: "e.g. 480000",
    calcEmpty: "Enter to match tier",
    tierPrefix: "Tier",
    matched: "Matched To Your Claim",
    mostRetained: "Most Retained",
    cta: "Initiate Under This Tier",
    tiers: [
      { name: "Standard Commercial", range: "Claims up to $250,000 USD", feeSuffix: "USD Fixed", timeframe: "Fast-track 10-day resolution", features: ["Sole Arbitrator Appointment", "Asynchronous Digital Docket", "AI Pre-Triage Evidence Summary", "Certified NY Convention Award", "24/7 Encrypted Portal Access"] },
      { name: "Enterprise & Corporate", range: "Claims $250,000 – $2,500,000 USD", feeSuffix: "USD Fixed", timeframe: "14-day formal adjudication", features: ["3-Member Tribunal Panel Option", "Emergency Injunction Review", "Priority AI Jurisdictional Analysis", "Virtual Oral Hearing Chamber", "Direct Cross-Border Service Notice", "Dedicated Legal Registrar"] },
      { name: "Sovereign & Complex", range: "Claims above $2,500,000 USD", feeSuffix: "Custom Statutory Fee Scale", timeframe: "Expedited or bespoke timeline", features: ["Custom Panel Selection from Roster", "Multi-Jurisdictional Conflict Resolution", "Bespoke Confidentiality Protocols", "Diplomatic Service Enforcement Support", "Concierge Legal Operations Team"] },
    ],
  },
  intake: {
    channel: "AES-256 Encrypted Channel",
    title: "Initiate Secure Arbitration",
    desc: "Complete the intake below to lodge a formal arbitral claim on the sovereign docket.",
    claimant: "Claimant Entity / Full Name",
    respondent: "Respondent Entity / Full Name",
    claimValue: "Estimated Claim Value (USD)",
    jurisdiction: "Governing Law / Jurisdiction",
    email: "Contact Email for Confirmations",
    summary: "Summary of Dispute & Arbitration Clause Reference",
    phClaimant: "e.g. Meridian Trading S.A.",
    phRespondent: "e.g. Novatek Logistics GmbH",
    phClaim: "480000",
    phSummary: "Describe the dispute and cite the arbitration clause (e.g. Clause 14.2 of the Master Supply Agreement)…",
    submit: "File Docket & Generate Reference Number",
    submitting: "Sealing Docket…",
    footnote: "Submission is GDPR Art. 32 compliant · eIDAS timestamped · Privileged & Confidential",
    successTitle: "Docket Filed — Reference {ref}",
    successBody: "Your arbitral claim has been lodged on the secure docket. A LexAegis registrar will make contact within one business day.",
    errorTitle: "Filing rejected",
    errorBody: "Please verify all fields and resubmit.",
  },
  portal: {
    tag: "2FA Secured · ISO 27001",
    title: "Secure Adjudicator Portal",
    email: "Registered Email",
    password: "Password",
    token: "Hardware Token Code (6 digits)",
    submit: "Authenticate Securely",
    verifying: "Verifying Credentials…",
    welcome: "Authenticated Session",
    dockets: "Filed Arbitral Dockets",
    inquiries: "Press & Investor Inquiries",
    logout: "Sign Out",
    empty: "No records on the docket yet.",
    errorInvalid: "Invalid credentials or account locked. Verify and retry.",
    statusLabel: "Status",
    statusLabels: ["Docket Filed", "Under Review", "Hearing Scheduled", "Award Issued"],
    downloadPdf: "Export PDF",
    updated: "Status updated",
    footnote: "Access restricted to empanelled arbitrators & registered counsel",
    toastTitle: "Demonstration Portal",
    toastBody: "Adjudicator and counsel credentials are provisioned exclusively by the Galano-Pacifico registrar office. This preview does not grant docket access.",
  },
  press: {
    overline: "Press & Investor Relations",
    titleA: "Media &",
    titleB: "Investor Desk",
    body: "Accredited journalists and institutional investors may reach the LexAegis communications office through this encrypted channel. All inquiries are handled under strict confidentiality by the Galano-Pacifico public affairs office.",
    secureNote: "PGP-encrypted channel · Response within 24 hours",
    fullName: "Full Name",
    org: "Media Outlet / Investment Firm",
    email: "Professional Email",
    type: "Inquiry Type",
    message: "Message",
    types: ["Press Kit Request", "Media Interview", "Investor Relations Briefing", "Financial Overview"],
    phName: "e.g. Alexandra Reyes",
    phOrg: "e.g. Financial Times / Meridian Capital",
    phMessage: "Outline your request, deadline, and the seniority of the spokesperson sought…",
    submit: "Submit Secure Inquiry",
    downloadKit: "Download Press Kit (PDF)",
    again: "Submit Another Inquiry",
    submitting: "Encrypting & Dispatching…",
    footnote: "Inquiries are privileged, GDPR Art. 32 compliant and never shared with third parties.",
    successTitle: "Inquiry Received — Reference {ref}",
    successBody: "Your inquiry has been logged with the communications office. Expect a response within 24 hours.",
    errorTitle: "Submission rejected",
    errorBody: "Please verify all fields and resubmit.",
  },
  footer: {
    compliance: "Operated strictly under international commercial arbitration statutes, the 1958 Convention on the Recognition and Enforcement of Foreign Arbitral Awards, and UNCITRAL rules. All docket data is processed under GDPR Article 32 with AES-256 encryption at rest and in transit.",
    institutional: "Institutional",
    links: ["Jurisdictional Rules", "Code of Judicial Ethics", "Adjudicating Panel", "Fee Scale & Calculator", "Institutional Advantage", "Press & Investor Desk"],
    secureTitle: "Secure Access",
    secureBody: "Empanelled arbitrators and registered counsel may access sealed dockets through the hardened portal.",
    portalBtn: "Secure Adjudicator Portal",
    ethics: "Professional Code of Ethics: every empanelled jurist is bound by the IBA Guidelines on Conflicts of Interest in International Arbitration.",
    copyright: "© 2026 LexAegis International — By Galano-Pacifico Law Firm & International Partners. All rights reserved.",
    sovereign: "Sovereign Extra-Judicial Tribunal",
  },
};
